import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HomeFilter, HomeFilterLevel } from '../models/client-configuration';
import { ConfigService } from './config.service';
import { SearchModel } from '../models/search-model';
import { Util } from '../util';

@Injectable({
  providedIn: 'root',
})
export class TopicService {
  
  private readonly configService = inject(ConfigService);
  private readonly router = inject(Router);
  
  topics: HomeFilter;

  constructor() {
    this.topics = this.configService.get().homeFilter;
  }

  goToResults(topic: HomeFilterLevel): void {
    const query = this.buildQuery(topic);
    this.router.navigate(['/results'], {
      queryParams: { query },
    });
  }

  private buildQuery(topic: HomeFilterLevel): string {
    const topics: string[] = this.topics.name.split(',');
    const criteriaArray = topics.flatMap((currentTopic) =>
      topic.criteria.map((_criteria) =>
        this.formatCriteria(currentTopic, _criteria)
      )
    );
    return criteriaArray.join(SearchModel.OR_KEYWORD);
  }

  private formatCriteria(topic: string, criteria: string): string {
    const formattedCriteria = this.shouldNotQuote()
      ? criteria
      : `"${criteria}"`;
    return `${topic}:${formattedCriteria}`;
  }

  private shouldNotQuote(): boolean {
    return this.topics.name === Util.THEMA_FILTER;
  }
}
